import React from "react";
import { withTranslation } from "react-i18next";
import Header from "../../components/Header/Header";
import Footer from "../../components/Footer/Footer";
import InfoTile from "../../components/InfoTile/InfoTile";
import { Building2, Layers, TrendingUp, MessageCircle } from "lucide-react";
import "./DlaInwestora.sass";

const pushTileEvent = (eventName) => {
  if (window.dataLayer) {
    window.dataLayer.push({ event: eventName });
  }
};

class DlaInwestora extends React.Component {
  componentDidMount() {
    document.title = "Dla Inwestora — BluHolding";
  }

  render() {
    const { t } = this.props;
    return (
      <div>
        <Header />
        <div className="DlaInwestora">
          <h1 className="DlaInwestora__title">{t("investorPageTitle")}</h1>
          <p className="DlaInwestora__intro">{t("investorPageIntro")}</p>
          <div className="DlaInwestora__tiles grid--2-1">
            <InfoTile
              to="/#o-nas"
              icon={<Building2 />}
              title={t("investorTile1Title")}
              subtitle={t("investorTile1Desc")}
              cta={t("investorTile1Cta")}
              hint={t("tileContinue")}
              onClick={() => pushTileEvent("ir_tile_poznaj_bluholding")}
            />
            <InfoTile
              to="/#opis-projektu"
              icon={<Layers />}
              title={t("investorTile2Title")}
              subtitle={t("investorTile2Desc")}
              cta={t("investorTile2Cta")}
              hint={t("tileContinue")}
              onClick={() => pushTileEvent("ir_tile_model")}
            />
            <InfoTile
              to="/aktualnosci"
              icon={<TrendingUp />}
              title={t("investorTile3Title")}
              subtitle={t("investorTile3Desc")}
              cta={t("investorTile3Cta")}
              hint={t("tileContinue")}
              onClick={() => pushTileEvent("ir_tile_rozwoj")}
            />
            <InfoTile
              to="/#kontakt-formularz"
              icon={<MessageCircle />}
              title={t("investorTile4Title")}
              subtitle={t("investorTile4Desc")}
              cta={t("investorTile4Cta")}
              hint={t("tileContinue")}
              onClick={() => pushTileEvent("ir_tile_kontakt")}
            />
          </div>
        </div>
        <Footer />
      </div>
    );
  }
}

export default withTranslation()(DlaInwestora);
